import React from 'react'

interface SlideContainerProps {
  children: React.ReactNode
}

export const SlideContainer: React.FC<SlideContainerProps> = ({ children }) => {
  return (
    <div className="slide-container bg-white shadow-lg overflow-hidden my-10 relative">
      {children}
    </div>
  )
}
